import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import '../style/all-projects.css';

const Design = (props) => {
  const images = props.images;
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const showcaseImgRef = useRef(null);

  const handleNextClick = () => {
    setCurrentImageIndex((currentImageIndex + 1) % images.length);
  };

  const handlePrevClick = () => {
    setCurrentImageIndex((currentImageIndex - 1 + images.length) % images.length);
  };

  useEffect(() => {
    const preloadImages = () => {
      images.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
    };
    preloadImages();
  }, [images]);

  return (
    <div className='single-project-row'>
      <div className="row single-project g-0">
      <div
        ref={showcaseImgRef}
        className={`col-lg-6 text-white showcase-img d-flex align-items-center justify-content-center ${props.left === true ? 'order-lg-2' : ''}`}
      >
        <img
          loading='eager'
          src={images[currentImageIndex]}
          alt={props.title}
          className="img-fluid project-image"
        />
      </div>

      <div className={`col-lg-6 showcase-text description-all-projects ${props.left === true ? 'order-lg-1' : ''}`}>
        <h2>{props.title}</h2>
        <p className="lead mb-0">
          {props.description}
        </p>
        <br />
        <Button href={props.link} className="btn-lg px-5 py-3 fs-6 fw-bolder" variant="outline-dark">View more</Button>
      </div>
      </div>
    </div>
    
  );
};

export default Design;
